import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api_url, DEFAULT_LOGO_SRC } from "../../constant/constant";

function PhishingPdfList() {
  const { t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const fetchReports = async (url) => {
    try {
    setLoading(true);
    var page = 1;
    console.log('url:',url);
    if (url !== "") {
      const temp = url.split("?page=");
      page = temp[1];
    }
    const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/reports/phishing/list?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      setReports(data.data || []);
      setLinks(data.links);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching reports:", error);
      setLoading(false);
    }
  };

  // ✔ PDF Download Function with Token
  const handleDownload = async (id,lang) => {
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/reports/phishing/get/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        console.error("Failed to download PDF");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // File name
      if(lang == "Arabic"){
        const link = document.createElement("a");
        link.href = url;
        link.download = `phishing-report-${id}.html`;
        link.click();
      }else{
        const link = document.createElement("a");
        link.href = url;
        link.download = `phishing-report-${id}.pdf`;
        link.click();
      }

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error in PDF download:", error);
    }
  };

  useEffect(() => {
    fetchReports("");
  }, []);

  return (
    <div className="container py-4">
      {loading ? (
        <p className="text-center">{t("Loading...")}</p>
      ) : reports.length === 0 ? (
        <p className="text-center">{t("No reports found")}</p>
      ) : (
        <div className="table-responsive-sm">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>{t("Language")}</th>
              <th>{t("Version")}</th>
              <th>{t("IssuedAt")}</th>
              <th>{t("Download")}</th>
            </tr>
          </thead>

          <tbody>
            {reports.map((item,index) => (
              <tr key={item.id}>
                
            <td>{index + 1}</td>  {/* <-- Sequence number */}
                <td>{item.language}</td>
                <td>{item.version}</td>
                <td>{new Date(item.issued_at).toLocaleDateString()}</td>

                <td style={{ width: "80px", textAlign: "center" }}>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleDownload(item.id, item.language)}
                  >
                    {t("Download")}
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null ? () => fetchReports(link.url) : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default PhishingPdfList;
